import { Auth0LoginRedirect } from '@wayste/auth-ui-shell';
import { Outlet, useLocation } from 'react-router-dom';
import { useOutletContext } from 'react-router-dom';
import PageLoader from '../../components/PageLoader/PageLoader';
import { RouterOutletContext } from '../router';

const AuthWrapper = () => {
    const context = useOutletContext<RouterOutletContext>();
    const location = useLocation();

    if (!context.userProfile) {
        return <Auth0LoginRedirect returnTo={location.pathname + location.search} loader={<PageLoader />} />;
    }

    return <Outlet context={context} />;
};

export default AuthWrapper;
